import { requestPostRes } from "../EdcService"

// 标记AI脱敏不准
export const markAIState = (taskId: string, reason: string)=> {
  return requestPostRes('ai/image/setState', { taskId, reason })
}